import { Box, Stack } from '@mui/material';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
import { FC } from 'react';

type ActivityTimelineItemSkeletonProps = {
    showDivider: boolean;
};

export const ActivityTimelineItemSkeleton: FC<ActivityTimelineItemSkeletonProps> = ({ showDivider }) => (
    <Stack
        direction="row"
        alignItems="flex-start"
        gap={1.5}
        sx={{
            p: 1.5,
            borderTop: showDivider ? '1px solid color-mix(in srgb, var(--tg-theme-text-color) 16%, transparent)' : 'none',
        }}
    >
        <ThemedSkeleton variant="rectangular" width={36} height={36} sx={{ borderRadius: '12px', flexShrink: 0 }} />
        <Box sx={{ flex: 1 }}>
            <ThemedSkeleton variant="text" width="70%" height={20} />
            <ThemedSkeleton variant="text" width="45%" height={16} />
        </Box>
    </Stack>
);
